const sidebar = {
	width: '14em'
}

export default sidebar;